// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3ighM","filesListContainer":"PosDisputesFiles_filesListContainer__2i5lL","filesButton":"PosDisputesFiles_filesButton__Bx7TZ"};